import styles from "./styles/sign-button.module.scss";
import React from "react";
import Link from "next/link";

const SignInButton = () => {
  return (
    <Link href={"/login"} className={styles.button}>
      Sign in
    </Link>
  );
};

export default SignInButton;
